module.exports = __webpack_public_path__ + "img/Ariel_University.651da506.svg";